import { render } from "./index.vue?vue&type=template&id=708a1ac2&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=708a1ac2&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=708a1ac2&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708a1ac2"]])

export default __exports__